export class BaseResultModel {
  Message = '';
  Success = false;
}
